import { RootState } from "src/redux/store";

export const opieLayoutsSelector = (state: RootState) => state.opieLayoutsStore.layouts;
export const opieLayoutsLoaderSelector = (state: RootState) => state.opieLayoutsStore.isLoading;
